import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '@Services/language.service';

/**
 * Guarda che si occupa di eliminare, se presente,
 * il fragment sul link con cui l'utente atterra sul B2C
 * dal portale SMN.
 *
 * Se intercetta il fragment, lo usa per settare la lingua
 * e riporta l'utente su un url corretto (senza fragment).
 *
 * Per farlo crea un UrlTree in modo da comunicare al router
 * di abbandonare la navigazione corrente (con fragment) in favore
 * di quella nuova che forniamo.
 *
 * @param route
 * @param state
 * @returns
 */
export const legacyUrlGuard: CanActivateFn = (_route, _state) => {

  const router = inject(Router);
  const langSvc = inject(LanguageService);

  // window.location.hash perche' il router di Angular ignora i fragment (#)
  const hash = window.location.hash;

  if (hash && hash.includes('/buyTicketless/')) {

    // Rimuoviamo il # iniziale
    const hashContent = hash.substring(1); // Es: it/buyTicketless/abc-123

    const [prefix, route, codesr] = hashContent.split('/');

    const supportedLangs = langSvc.$supportedLanguages.getValue();
    const prefixLang = supportedLangs.find((lang) => lang.lang_code === prefix);

    if (prefixLang) {
      langSvc.switchLanguageFromString(prefixLang.lang_code);
    } else {
      langSvc.switchLanguageFromString("en");
    }

    return router.createUrlTree([`/${route}/${codesr}`]);
  }

  return true;
};
